import PropTypes from 'prop-types';
import HomepageGift from './homepageGift';
import PointsBlock from './pointsBlock';
// import {NavLink} from 'react-router-dom';
import {SmallTitle, MainTitle, Button, Hr} from 'ui';
import {Container, Small, Gifts} from './styles';
import {query} from 'api';

const HomepageGifts = ({data}) => {
  if (!data) return null;
  return (
    <Container>
      <Hr />
      <PointsBlock />
      <SmallTitle>Votre fidélité récompensée</SmallTitle>
      <MainTitle>Les Cadeaux du Club Maison Carte d’Or</MainTitle>
      <Gifts>
        {data.map(gift => (
          <HomepageGift key={`${gift.id}`} {...gift} />
        ))}
      </Gifts>
      <Small>Liste non exhaustive des cadeaux</Small>
      <Button color="white" style={{margin: 'auto'}} to="/gifts">
        Voir tous les cadeaux
      </Button>
    </Container>
  );
};

HomepageGifts.propTypes = {
  data: PropTypes.array,
};

export default HomepageGifts |> query('getHomepageGifts');
